// Locale-aware date / duration helpers.

export function formatDateTime(
  iso: string | null | undefined,
  locale = 'en',
  options: Intl.DateTimeFormatOptions = { dateStyle: 'medium', timeStyle: 'short' },
): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat(locale, options).format(d);
}

export function formatDate(iso: string | null | undefined, locale = 'en'): string {
  return formatDateTime(iso, locale, { dateStyle: 'medium' });
}

export function formatTime(iso: string | null | undefined, locale = 'en'): string {
  return formatDateTime(iso, locale, { timeStyle: 'short' });
}

// Returns "3h 47m" / "16h 30m" — used for boarding passes / countdowns.
export function formatDurationCompact(minutes: number, locale = 'en'): string {
  if (!Number.isFinite(minutes) || minutes < 0) return '—';
  const h = Math.floor(minutes / 60);
  const m = Math.round(minutes % 60);
  const nf = new Intl.NumberFormat(locale);
  if (h === 0) return `${nf.format(m)}m`;
  if (m === 0) return `${nf.format(h)}h`;
  return `${nf.format(h)}h ${nf.format(m)}m`;
}

// Difference between target and now, in minutes (negative if past).
export function minutesUntil(iso: string | null | undefined): number {
  if (!iso) return 0;
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 0;
  return Math.round((t - Date.now()) / 60000);
}
